import {configParamsModule} from "../../configParamsModule";
import {
    LoadingService,
    MessagesModal,
    RemoteExceptionHandler
} from "../../../../bower_components/front-end-web-commons";
import {PermissionGroupSupportService} from "./permissionGroupSupportService";
import {OptimizationConfiguration} from "../../model/optimizationConfiguration";
import {IntegrationConfiguration} from "../../model/integrationConfiguration";

class PermissionGroupSupportController {
    permissionGroupId: number
    optimizationConfiguration: OptimizationConfiguration;
    integrationConfiguration: IntegrationConfiguration;
    geocodificationProvider: string;

    constructor(private permissionGroupSupportService: PermissionGroupSupportService,
                private loadingService: LoadingService,
                private $q: ng.IQService,
                private remoteExceptionHandler: RemoteExceptionHandler,
                private messagesModal: MessagesModal,
                private permissionGroup: any) {

        this.permissionGroupId = permissionGroup.id
        let configurations = [this.loadOptimizationConfigurations(), this.loadIntegrationConfigurations(), this.getGeocodificationProviderByPermissionGroup()]
        this.loadingService(this.$q.all(configurations));
    }


    purgeProgrammingDatabase() {
        return this.messagesModal.cancellable("dialog.warning", [{
            keyBundle: "config.params.database.purge.warning.message",
            parameters: [this.permissionGroup]
        }])
            .then(() => this.messagesModal("dialog.success", ["config.params.database.purge.started"])
                .then(() => this.permissionGroupSupportService.purgeProgrammingDatabase()
                    .catch(this.remoteExceptionHandler()))
            );
    }

    purgeExecutionDatabase() {
        return this.messagesModal.cancellable("dialog.warning", [{
            keyBundle: "config.params.database.purge.warning.message",
            parameters: [this.permissionGroup]
        }])
            .then(() => this.messagesModal("dialog.success", ["config.params.database.purge.started"])
                .then(() => this.permissionGroupSupportService.purgeExecutionDatabase()
                    .catch(this.remoteExceptionHandler()))
            );
    }

    saveOptimizationConfigurations() {
        return this.loadingService(this.permissionGroupSupportService.saveOptimizationConfigurations(this.optimizationConfiguration))
            .catch(this.remoteExceptionHandler())
            .then(() => this.messagesModal("dialog.success", "config.params.save.configurations.success"))
            .then(() => this.loadingService(this.loadOptimizationConfigurations()))
    }

    saveIntegrationConfigurations() {
        return this.loadingService(this.permissionGroupSupportService.saveIntegrationConfigurations(this.integrationConfiguration))
            .catch(this.remoteExceptionHandler())
            .then(() => this.messagesModal("dialog.success", "config.params.save.integration.success"))
            .then(() => this.loadingService(this.loadOptimizationConfigurations()))
    }

    private loadOptimizationConfigurations() {
        return this.permissionGroupSupportService.findOptimizationConfigurations()
            .then(result => {
                this.optimizationConfiguration = result;
            }).catch(this.remoteExceptionHandler())
    }

    private loadIntegrationConfigurations() {
        return this.permissionGroupSupportService.findIntegrationConfigurations()
            .then(result => {
                this.integrationConfiguration = result;
            }).catch(this.remoteExceptionHandler())
    }

    private getGeocodificationProviderByPermissionGroup() {
        return this.permissionGroupSupportService.getGeocodificationProviderByPermissionGroup()
            .then(result => {
                this.geocodificationProvider = result;
            }).catch(this.remoteExceptionHandler())
    }

    formatGeocodificationProvider(config) {
        if (config?.geocodificationProvider) {
            return config.geocodificationProvider
        }
        return config;
    }

    retrieveGeocodificationProviders() {
        return this.permissionGroupSupportService.retrieveGeocodificationProviders()
    }

    saveGeocodificationProviderConfig() {
        const payload = {
            provider: this.geocodificationProvider
        }
        return this.loadingService(this.permissionGroupSupportService.saveGeocodificationProviderConfiguration(payload))
            .catch(this.remoteExceptionHandler())
            .then(() => this.messagesModal("dialog.success", "config.params.save.integration.success"))
            .then(() => this.loadingService(this.getGeocodificationProviderByPermissionGroup()))
    }
}

configParamsModule.controller("permissionGroupSupportController", PermissionGroupSupportController);